
import { createContext } from "react";

import { NotifySiteResponse, TrialMetadata } from "@/apis/dtos";
import useGetTrialByOid from "@/hooks/data/useGetTrialByOid";


export interface ITrialContext extends Omit<ReturnType<typeof useGetTrialByOid>, 'data' | 'total' | 'offset'> {
    data?: TrialMetadata,
    emailSite?: (trialId?: number, institutionCode?: string, trialCoordinatorIds?: number[]) => Promise<NotifySiteResponse>
}

export const TrialContext = createContext<ITrialContext>({
    data: undefined,
    emailSite: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});